// Main path on server
export const pathHomePage = "";

export const WEB_SERVICE_DASHBOARD_ROUTE = `https://rgsweb.eodyne.com/rgsmims/backend/dashboard/src`;

// Roles y a donde entra cada uno al hacer login.
// environment null significa que el usuario elige entorno en la pantalla de
// seleccion; el resto lo tienen fijado y no pasan por ella.
export const userRoles = {
  ADMIN: "ADMIN",
  GUEST: "GUEST",
  PROJECTS: "PROJECTS",
  DISTRIBUTOR: "DISTRIBUTOR",
};

export const roleAccess = {
  [userRoles.ADMIN]: { environment: null, landingPage: "/home" },
  [userRoles.GUEST]: { environment: null, landingPage: "/home" },
  [userRoles.PROJECTS]: { environment: "global_production", landingPage: "/hospitals-by-project" },
  [userRoles.DISTRIBUTOR]: { environment: "global_production", landingPage: "/budget" },
};

// Altura de la barra superior del distribuidor. El menu lateral la usa como
// padding superior para que su primer elemento arranque justo donde acaba la
// barra blanca, sin que haya que cuadrar dos numeros a mano.
export const topBarHeight = "64px";

// Menu lateral del distribuidor. De momento solo tiene una vista, pero se
// mantiene como lista para cuando haya mas y haya que cambiar entre ellas.
export const distributorMenu = [{ key: "budgetGenerator", path: "/budget" }];

export const eodyneWebsite = "https://www.eodyne.com";

// Budget generator
//
// Politica comercial de la licencia, igual para todos los distribuidores. Lo
// unico que varia por distribuidor es la cuota base, que viene de
// distributor_article.PRICE.
export const licenseConfig = {
  // Descuento por volumen que se alcanza justo con discountRange terapeutas.
  maxDiscount: 0.25,
  discountRange: 20,
  maxTherapists: 15,
  maxYears: 10,
};

// Descuento por permanencia, en puntos porcentuales.
export const permanenceDiscount = {
  step: 1,
  max: 50,
};

// Impuestos, en puntos porcentuales. Se aplican sobre la base ya descontada,
// como en una factura.
export const taxConfig = {
  step: 1,
  max: 30,
  defaultValue: 21,
};

// Distribucion de la pantalla. La base de datos solo dice que articulos ve el
// distribuidor y a que precio; como se agrupan y en que orden se decide aqui.
// Las claves coinciden con article.ARTICLE_KEY, con las traducciones y con las
// imagenes de assets/items.
export const budgetGroups = [
  {
    key: "rgs_clinic",
    type: "pack",
    articleKey: "rgs_clinic",
    contents: ["pc", "orbbec", "leap_motion", "monitor", "accessories", "setup", "forearm_support"],
  },
  {
    key: "rgs_plus",
    type: "articles",
    articleKeys: ["rgs_plus_tablet", "rgs_plus_phone_holder"],
  },
  {
    key: "rgs_ecosystem_license",
    type: "license",
    articleKey: "rgs_ecosystem_license",
  },
];

// Mims Colors
export const primaryColor = "#26A9B6";
export const primaryColorHover = "#1A737B";
export const bodyColor = "#E6E6E6";
export const errorColor = "#D9434E";
export const patientCreationPeriodColor = "#FEB416";
export const colorsArray = [
  "#FDF201",
  "#55BA4C",
  "#004FA2",
  "#FF0E4B",
  "#FEB416",
  "#5D2D91",
  "#00AEF0",
  "#00A66C",
  "#F37520",
  "#303092",
  "#EB0089",
  "#A6CE3B",
  "#0072BB",
  "#E8371F",
  "#00A99E",
  "#92278F",
  "#FF6633",
  "#1AFF33",
  "#6666FF",
  "#E6B333",
  "#FF3399",
  "#00CC66",
  "#990099",
  "#FF9966",
  "#0099CC",
  "#CC6699",
  "#33FFCC",
  "#660066",
  "#FFCC33",
  "#339999",
  "#CC3366",
  "#990000",
  "#336699",
  "#CC3300",
  "#FF9999",
  "#66CCFF",
  "#990066",
  "#663366",
  "#FF9966",
  "#CC6600",
  "#009966",
  "#CCCC33",
  "#996666",
  "#FF3366",
  "#66FFCC",
  "#FF6600",
  "#006633",
  "#CCCC00",
  "#666633",
  "#FF3300",
  "#66CC00",
  "#663300",
  "#FF3300",
  "#009933",
  "#993366",
  "#FF3333",
  "#99CC00",
  "#006666",
  "#FF6633",
  "#33CC99",
  "#990033",
];

// Applications
export const applications = {
  clinicId: 1,
  homeId: 2,
  webId: 3,
  appId: 4,
  wearId: 5,
  icuId: 6,
  plusId: 7,
};

// Station available versions
export const stationVersions = ["5.0", "5.1", "5.2", "5.3", "5.4", "5.4.1", "5.4.2"];

// Protocols
export const protocols = {
  clinicAndHome: {
    SPHEROIDS_ID: 10,
    PINBALL_ID: 40,
    HOCKEY_ID: 50,
    CLEAN_THE_TABLE_ID: 60,
    GRASP_AND_PLACE_ID: 90,
    FOLLOW_THE_LINE_ID: 100,
    ROAD_TRIP_ID: 110,
    BRICKS_ID: 120,
    BOAT_ID: 140,
    BUBBLES_ID: 151,
    DEMOLITION_ID: 152,
    CATERING_ID: 153,
    CONSTELLATIONS_ID: 80,
    TWISTER_BUDDY_ID: 309,
    COSTUME_PARTY_ID: 310,
    GENTLE_GIANT_ID: 311,
  },
  app: {
    basic: {
      MEMOSEQ_APP_ID: 201,
      PLACE_IT_ID: 204,
      GUESS_WHAT_ID: 202,
      PIANOSEQ_ID: 203,
      BLOBS_ID: 214,
      SHOPPING_ID: 215,
      POPURRI_ID: 222,
      TWISTER_ID: 223,
      MEMORY_ID: 224,
      CLEANING_ID: 216,
      CONSTELLATIONS: 229,
      BALLOONS_BASIC: 231,
      QUALITY_CONTROL_BASIC: 232,
    },
    tensorFlow: {
      ARMANOID_ID: 211,
      DRIVING_ID: 217,
    },
    ar: {
      TRAINING_ID: 200,
      SHELVES_ID: 208,
      BUFFET_ID: 210,
      ALPHABET_ID: 205,
      BALLOONS_ID: 206,
      DUCKS_ID: 209,
      SPHEROIDS_AR_ID: 218,
      HOCKEY_AR_ID: 219,
      CIRCLE_AR_ID: 220,
      WHAC_A_MOLE_AR_ID: 221,
      TUBES_ID: 226,
      CLEANING_AR_ID: 225,
      CLEANING_AR_VERTICAL_ID: 227,
      CIRCLE_HORIZONTAL_ID: 228,
      QUALITY_CONTROL_ID: 230,
      CONSTELLATIONS_AR: 233,
    },
  },
  web: {
    MEMOSEQ_WEB_ID: 301,
    MIRROR_WEB_ID: 302,
    RECYCLING_WEB_ID: 303,
    WHACK_A_MOLE_WEB_ID: 304,
    FULL_BODY_ID: 305,
    BALANCE_ID: 306,
    SEQUENCES_ID: 307,
    WORDS_ID: 308,
    TWISTER_BUDDY_ID: 309,
    COSTUME_PARTY_ID: 310,
    GENTLE_GIANT_ID: 311,
  },
};

// Adherence
export const AdherenceColorLow = "#ed1c24";
export const AdherenceColorMedium = "#fbb03b";
export const AdherenceColorHigh = "#39b54a";
export const adherenceLevel = {
  lowToMedium: 50,
  MediumToHigh: 74,
};
